import { SettingsApiTypes } from "@rshbintech.dboul/http";
import { getSetting } from "./get-settings";

export const getFeatureToggle = (
  settings: SettingsApiTypes.ClientSettings["settings"] | null,
  name: string,
  groupKey: string,
  systemId?: string
): boolean => {
  try {
    const value = getSetting(settings, name, groupKey, systemId);

    return value === "true";
  } catch (e) {
    return false;
  }
};
